module.exports = __webpack_public_path__ + "images/category_lp/bike/assessment_achievements/5_312cdb6a1a99df4d86d6a13176ff528d.jpg";